<template lang="pug">
    v-form(ref="logVirtualAccountForm" id="logVirtualAccountForm" @submit.prevent="doFind" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg8 md8 xs12)
                    v-text-field(dense v-model="virtualAccountValue" label="No. Virtual Account" required readonly)
            v-layout(wrap)
                v-flex(lg2 md2 xs12)
                    v-checkbox(v-model="filterLimit" label="n-Transaksi")
                v-flex(lg4 md4 xs12)
                    v-radio-group(v-model="limit" row :readonly="!filterLimit")
                        v-radio(label="5" value="5")
                        v-radio(label="10" value="10")
                        v-radio(label="15" value="15")
            v-layout(wrap)
                v-flex(lg2 md2 xs12)
                    v-checkbox(v-model="filterPeriod" label="Periode")
                v-layout(wrap)                                            
                    v-flex(lg2 md2 xs12 class="mx-1" )
                        f-date-box(v-model="startDate" :readonly="!filterPeriod" label="Periode Awal")
                    v-flex(lg2 md2 xs12 class="mx-1" )
                        f-date-box(v-model="endDate" :readonly="!filterPeriod" label="Periode Akhir")
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" type="submit" form="logVirtualAccountForm") Cari
                    v-icon mdi-magnify
                    
</template>
<script>
export default {
    name: "FLogVirtualAccountForm",
    props: ["va", "merchant"],
    data() {
        return {
            virtualAccount: {
                virtualAccountNumber: null,
                virtualAccountName: ""
            },
            limit: "5",
            startDate: null,
            endDate: null,
            filterLimit: true,
            filterPeriod: false,
        }
    },
    watch: {
        va(val){
            this.doInit(val);
        },
        filterLimit(value) {
            this.filterPeriod = value ? false : true;
        },
        filterPeriod(value) {
            this.filterLimit = value ? false : true;
        },
    },
    computed: {
        virtualAccountValue() {
            if (this.virtualAccount) {
                return this.virtualAccount.virtualAccountNumber + " - " + this.virtualAccount.virtualAccountName
            }
        }
    },
    mounted() {
        this.doInit(this.va);
    },
    methods: {
        doInit(values){
            if (this.$refs.logVirtualAccountForm) {
                this.$refs.logVirtualAccountForm.resetValidation();
            }
            this.startDate = this.$options.filters.localdate(new Date());
            this.endDate = this.$options.filters.localdate(new Date());
            this.filterLimit = true;
            this.filterPeriod = false;
            this.limit = "5";
            this.virtualAccount = values ? values : {
                virtualAccountNumber: "",
                virtualAccountName: ""
            };
        },
        doCancel(){
            this.$refs.logVirtualAccountForm.resetValidation();
            this.$emit("cancel");
        },
        doFind(){
            if(this.$refs.logVirtualAccountForm.validate()){
                let param = {
                    periode: this.filterLimit ? this.limit + " Transaksi Terakhir" : this.$options.filters.dateformat(this.startDate) +
                        " s/d " + this.$options.filters.dateformat(this.endDate),
                    filterLimit: this.filterLimit,
                    filterPeriod: this.filterPeriod,
                    limit: this.limit,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    virtualAccountNumber: this.virtualAccount.virtualAccountNumber
                }
                this.$emit("findParam", param);
            }
        }
    },
}
</script>